module.exports = __webpack_public_path__ + "images/d0c318b58d1ee6976088b617d3f4ee0770bdf68bf35e68375f0b35492f47f7d8.svg";